import { fromJS } from 'immutable';
import Enum from 'enum';

export const DIGIT_MATRIX = fromJS([
    ['1', '2', '3', 'A'],
    ['4', '5', '6', 'B'],
    ['7', '8', '9', 'C'],
    ['*', '0', '#', 'D'],
]);

export const DIGIT_DTMF_FREQUENCIES = fromJS({
    ROW: [697, 770, 852, 941],
    COL: [1209, 1336, 1477, 1633],
});

/* -- Tone Setups --
 * The setup object consist of a dual frequenzy tone and a on-off wave.
 * The wave is represented by an array where the first value is time(ms) on,
 * then alternating between on and off.
 *
 * An array inside the array is a repeating pattern,
 * where the first value is on-time, the second is off-time
 * and the third is times repeated.
 * [on, off, repeat]
 */
export const RINGBACK_SETUP = new Enum(
    {
        UK: {
            frequency1: 400,
            frequency2: 450,
            wave: [400, 200, 400, 2000],
        },
        GB: {
            frequency1: 400,
            frequency2: 450,
            wave: [400, 200, 400, 2000],
        },
        ES: {
            frequency1: 425,
            frequency2: 0,
            wave: [1500, 3000],
        },
        PT: {
            frequency1: 425,
            frequency2: 0,
            wave: [1000, 5000],
        },
        DE: {
            frequency1: 425,
            frequency2: 0,
            wave: [1000, 4000],
        },
        DEFAULT: {
            frequency1: 425,
            frequency2: 0,
            wave: [1000, 4000],
        },
    },
    { ignoreCase: true },
);

export const BUSY_TONE_SETUP = new Enum(
    {
        UK: {
            frequency1: 400,
            frequency2: 0,
            wave: [375, 375],
        },
        GB: {
            frequency1: 400,
            frequency2: 0,
            wave: [375, 375],
        },
        ES: {
            frequency1: 425,
            frequency2: 0,
            wave: [200, 200],
        },
        PT: {
            frequency1: 425,
            frequency2: 0,
            wave: [500, 500],
        },
        IT: {
            frequency1: 425,
            frequency2: 0,
            wave: [500, 500],
        },
        DE: {
            frequency1: 425,
            frequency2: 0,
            wave: [480, 480],
        },
        DEFAULT: {
            frequency1: 425,
            frequency2: 0,
            wave: [[500, 500, 3], 500, 1000],
        },
    },
    { ignoreCase: true },
);

export const DISCONNECT_TONE_SETUP = new Enum(
    {
        IT: {
            frequency1: 425,
            frequency2: 0,
            wave: [200, 200],
        },
        DEFAULT: {
            frequency1: 450,
            frequency2: 0,
            wave: [250],
        },
    },
    { ignoreCase: true },
);

export const CALL_WAITING_SETUP = new Enum(
    {
        ES: {
            frequency1: 425,
            frequency2: 0,
            wave: [175, 175, 175, 3500],
        },
        PT: {
            frequency1: 425,
            frequency2: 0,
            wave: [200, 200, 200, 5000],
        },
        IT: {
            frequency1: 425,
            frequency2: 0,
            wave: [400, 100, 250, 100, 150, 14000],
        },
        DE: {
            frequency1: 425,
            frequency2: 0,
            wave: [200, 200, 200, 5000],
        },
        DEFAULT: {
            frequency1: 425,
            frequency2: 0,
            wave: [200, 500, 200, 3000],
        },
    },
    { ignoreCase: true },
);
